import React, { useState } from "react";
import { toast } from "react-toastify";
import Button from "../../../../atoms/Button";

const ModalEditDate = ({ onClose, documento, onConfirm, loading }) => {
    const [newDate, setNewDate] = useState(documento?.fecha || "");

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (!newDate) {
            toast.error("Por favor selecciona una fecha válida");
            return;
        }

        // Validar que la fecha no sea futura
        const selectedDate = new Date(newDate);
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (selectedDate > today) {
            toast.error("La fecha no puede ser futura");
            return;
        }

        onConfirm(newDate);
    };

    return (
        <div className="p-6">
            <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                    <label htmlFor="fecha" className="block text-sm font-medium text-gray-700 mb-2">
                        Fecha actual: <span className="font-bold">{documento?.fecha}</span>
                    </label>
                    <label htmlFor="fecha" className="block text-sm font-medium text-gray-700 mb-2">
                        Nueva fecha:
                    </label>
                    <input
                        type="date"
                        id="fecha"
                        value={newDate}
                        onChange={(e) => setNewDate(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        required
                    />
                </div>

                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
                    <div className="flex">
                        <div className="flex-shrink-0">
                            <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                        </div>
                        <div className="ml-3">
                            <p className="text-sm text-yellow-700">
                                Esta acción actualizará la fecha del documento y todos los títulos de los archivos asociados.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="flex justify-end space-x-3">
                    <Button
                        text="Cancelar"
                        bgColor="gray"
                        onClick={onClose}
                        type="button"
                        disabled={loading}
                    />
                    <Button
                        text={loading ? "Actualizando..." : "Actualizar fecha"}
                        bgColor="blue"
                        type="submit"
                        disabled={loading}
                    />
                </div>
            </form>
        </div>
    );
};

export default ModalEditDate;